import { render, staticRenderFns } from "./fqType.vue?vue&type=template&id=1223e74f"
import script from "./fqType.vue?vue&type=script&lang=js"
export * from "./fqType.vue?vue&type=script&lang=js"
import style0 from "./fqType.vue?vue&type=style&index=0&id=1223e74f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports